<template>
  <div id="cart-parent">
    <div v-if="emptyOrNot == true && !condition2" class="empty-cart">
      <img src="../assets/illustrations/cartempty.svg" height="50%" width="50%" />
      <h2>Oh!</h2>
      <p>Looks like you haven't added any product to your cart</p>
    </div>

    <v-card v-if="iogglyInCartOnly == false && condition2" id="productInCart">
      <div id="cartcc">My Cart({{ showcart.length }})</div>
      <v-divider></v-divider>
      <div v-for="(cart, idx) in showcart" :key="idx">
        <div class="ux-card" :id="cart.spaceid">
          <div v-if="cart.status == 'Verified'" class="productdet">
            <img class="productImage" :src="cart.img_url[0]" height="150px" width="150px" />
            <div class="productspec">
              <p class="productDelivery"></p>
              <a class="productOffer"></a>
              <p class="productHeading">{{ cart.subcategory }}</p>
              <p class="productDimension">Dimensions {{ cart.height }}x{{ cart.width }}</p>

              <p class="productSubHeading">{{ cart.category }}</p>

              <p class="productPrice">
                Rs.
                {{ Math.round(cart.price).toLocaleString("en-IN") }}
              </p>
            </div>
          </div>
          <div v-else style="filter: blur(3px);" class="productdet">
            <img class="productImage" :src="cart.img_url[0]" height="150px" width="150px" />
            <div class="productspec">
              <p class="productDelivery"></p>
              <a class="productOffer"></a>
              <p class="productHeading">{{ cart.subcategory }}</p>
              <p class="productDimension">Dimensions {{ cart.height }}x{{ cart.width }}</p>

              <p class="productSubHeading">{{ cart.category }}</p>

              <p class="productPrice">
                Rs.
                {{
                Number(
                Math.round(+cart.price + "e" + 2) + "e-" + 2
                ).toLocaleString("en-IN")
                }}
              </p>
            </div>
          </div>
          <div class="productbtn">
            <span
              v-if="cart.status !== 'Verified'"
              style="font-size: 1.8em;padding: 0 8px;margin-bottom: 5px;"
            >Out Of Stock !!</span>
            <v-btn
              outline
              color="warning"
              class="productBtn"
              @click="moveToWishlist(cart.spaceid)"
            >Move To Wishlist</v-btn>
            <v-btn
              outline
              color="red"
              class="productBtn"
              @click="removeFromCart(cart.spaceid)"
            >Remove</v-btn>
          </div>
        </div>
        <v-divider v-if="idx !== showcart.length - 1"></v-divider>
      </div>
      <v-divider v-if="canShowIogglySupportLeft == true"></v-divider>
      <div v-if="canShowIogglySupportLeft == true" class="ux-card">
        <div class="productdet">
          <img src="../assets/illustrations/supportill.svg" class="productImage" width="90px " />
          <div class="productspec">
            <p class="productDelivery"></p>
            <a class="productOffer"></a>
            <p class="support" style="width : 10rem;">iOggly Support</p>
            <p class="productDimension" style="width: 270px;">
              Get iOggly Support and enjoy great benefits and premium services
              from our side
            </p>

            <p class="productSubHeading"></p>

            <!-- <p class="productPrice">Rs.999</p> -->
            <div class="style-1">
              <del>
                <span class="amount">₹ 999</span>
              </del>
              <ins>
                <span class="amount">₹ 0</span>
              </ins>
            </div>
          </div>
        </div>
        <div class="productbtn" style="    width: 184.31px;">
          <v-btn outline color="red" @click="removeIogglySupport()">Remove</v-btn>
        </div>
      </div>
      <div class="gobacktoshopping">
        <v-btn outline class="actionbtn" @click="tohome">
          <v-icon small>arrow_back_ios</v-icon>Continue Shopping
        </v-btn>
        <v-btn
          class="actionbtn"
          color="warning"
          @click="checkout"
          v-if="this.totalPrice != 0"
        >checkout</v-btn>
      </div>
    </v-card>
    <v-card v-if="iogglyInCartOnly == true" id="productInCart">
      <div class="ux-card">
        <div class="productdet">
          <img src="../assets/illustrations/supportill.svg" class="productImage" width="90px " />
          <div class="productspec">
            <p class="productDelivery"></p>
            <a class="productOffer"></a>
            <p class="support" style="width : 10rem;">iOggly Support</p>
            <p class="productDimension" style="width: 270px;">
              Get iOggly Support and enjoy great benefits and premium services
              from our side
            </p>

            <p class="productSubHeading"></p>

            <!-- <p class="productPrice">Rs.999</p> -->
            <div class="style-1">
              <del>
                <span class="amount">₹1999</span>
              </del>
              <ins>
                <span class="amount">₹0</span>
              </ins>
            </div>
          </div>
        </div>
        <div class="productbtn" style="width: 184.31px;">
          <v-btn outline color="red" @click="removeIogglySupport()">Remove</v-btn>
        </div>
      </div>
      <div class="gobacktoshopping">
        <v-btn outline class="actionbtn" @click="tohome">
          <v-icon small>arrow_back_ios</v-icon>Continue Shopping
        </v-btn>
        <v-btn class="actionbtn" color="warning" @click="checkout">checkout</v-btn>
      </div>
    </v-card>
    <div id="payment" v-if="iogglyInCartOnly == false && condition2">
      <v-card class="paymentInfo">
        <span class="pricedete">Price Detail</span>
        <div id="staticData">
          <p class>Price</p>
          <P class>GST</P>
          <p>Discount Price</p>
          <p class>Amount Payable</p>
        </div>
        <div id="dyanamicData">
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[0] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[1] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[3] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[2] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
        </div>
        <div class="checkoutnow"></div>
      </v-card>
      <br />
      <div
        style="box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
      >
        <span class="pricedete">Promotion</span>
        <span class="promo-parent">
          <input
            type="text"
            placeholder="Enter Coupons"
            id="promo-input"
            v-model="promoEntered"
            :disabled="promoappliedButton == true"
          />
          <v-btn
            outline
            color="black"
            class="productBtn"
            v-if="promoappliedButton == false"
            @click="applyCoupon()"
          >Apply</v-btn>
          <v-btn outline color="black" class="productBtn" v-else @click="removeCoupon()">Remove</v-btn>
        </span>
        <span
          v-if="promoError"
          style="padding-bottom: 10px;display: flex;flex-direction: column;justify-content: center;align-content: center;align-items: center;color: red;"
        >
          <span v-if="promoError == 'notCorrect'">&#10006; Enter Correct Promotion Code</span>
          <span v-else-if="promoError == 'minimumCart'">&#10006; Minimum Cart Size Not Achived</span>
          <span v-else-if="promoError == 'offerExp'">&#10006; Offer Expired</span>
          <span
            v-else-if="promoError == 'success'"
            style="color:green"
          >&#10004; Promotion Discount Applied</span>
        </span>
      </div>
      <br />

      <v-card v-if="hasIoggySupport == false" class="paymentInfo2">
        <div class="support1">
          Add iOggly Support package and get the best service from experts. Now,
          iOggly Support is totally free.
          <div class="style-1">
            <del>
              <span class="amount">₹1999</span>
            </del>
            <ins>
              <span class="amount">₹0</span>
            </ins>
          </div>
        </div>
        <div class="support2">
          <img src="../assets/illustrations/supportill.svg" class="supportill" />
          <v-btn @click="addIogglySupport" color="warning">Add Now</v-btn>
        </div>
      </v-card>
      <div class="securepay">
        <img
          src="//img1a.flixcart.com/www/linchpin/fk-cp-zion/img/shield_a7ea6b.png"
          class="securepayimg"
        />
        <span class="securepaydec">Safe and Secure Payments 100% .</span>
      </div>
    </div>
    <div id="payment" v-if="iogglyInCartOnly == true">
      <v-card class="paymentInfo">
        <span class="pricedete">Price Detail</span>
        <div id="staticData">
          <p class>Price</p>
          <P class>GST</P>
          <p class>Discount Price</p>
          <p class>Amount Payable</p>
        </div>
        <div id="dyanamicData">
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[0] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[1] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[3] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
          <p class>
            Rs.
            {{
            Number(
            Math.round(priceArr[2] + "e" + 2) + "e-" + 2
            ).toLocaleString("en-IN")
            }}
          </p>
        </div>
        <div class="checkoutnow"></div>
      </v-card>

      <div class="securepay">
        <img
          src="//img1a.flixcart.com/www/linchpin/fk-cp-zion/img/shield_a7ea6b.png"
          class="securepayimg"
        />
        <span class="securepaydec">Safe and Secure Payments 100% .</span>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import * as firebase from "firebase";
import { db } from "@/main";

export default {
  name: "Cart",
  data() {
    return {
      cart: [],
      userData: [],
      spaceid: [],
      totalPrice: 0,
      lCart: [],
      lCartCount: [],
      priceArr: ["0", "0", "0", "0"],
      oldpirceArr: null,
      cartValid: true,
      promoEntered: null,
      promoError: null,
      promoappliedButton: false
    };
  },
  computed: {
    emptyOrNot() {
      if (
        this.$store.state.userData &&
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.userData.iogglysupport &&
        this.$store.state.userData.iogglysupport == true
      ) {
        return true;
      } else if (
        this.$store.state.localCart &&
        this.$store.state.localCart.length > 0
      ) {
        return false;
      } else if (
        this.$store.state.userData &&
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.userData.iogglysupport &&
        this.$store.state.userData.iogglysupport == false
      ) {
        return false;
      } else if (
        this.$store.state.userData &&
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        !this.$store.state.userData.iogglysupport &&
        this.$store.state.iogglysupportneeded == true
      ) {
        return false;
      } else if (
        !this.$store.state.userData &&
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.iogglysupportneeded == true
      ) {
        return false;
      } else if (
        !this.$store.state.userData &&
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.iogglysupportneeded == false
      ) {
        return true;
      } else {
        return true;
      }
    },
    iogglyInCartOnly() {
      if (
        !this.$store.state.userData &&
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.iogglysupportneeded == true
      ) {
        return true;
      } else if (
        !this.$store.state.userData &&
        !this.$store.state.localCart &&
        this.$store.state.iogglysupportneeded == true
      ) {
        return true;
      } else if (
        !this.$store.state.localCart &&
        this.$store.state.iogglysupportneeded == true &&
        this.$store.state.userData &&
        this.$store.state.userData.iogglysupport == true
      ) {
        return false;
      } else if (
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.iogglysupportneeded == true &&
        this.$store.state.userData &&
        this.$store.state.userData.iogglysupport == true
      ) {
        return false;
      } else if (
        this.$store.state.localCart &&
        this.$store.state.localCart.length == 0 &&
        this.$store.state.iogglysupportneeded == true &&
        this.$store.state.userData &&
        !this.$store.state.userData.iogglysupport
      ) {
        return true;
      } else {
        return false;
      }
    },
    canShowIogglySupportLeft() {
      if (
        this.$store.state.userData &&
        this.$store.state.userData.iogglysupport == true
      ) {
        return false;
      } else if (this.$store.state.iogglysupportneeded == true) {
        return true;
      } else {
        return false;
      }
    },
    hasIoggySupport() {
      if (
        this.$store.state.userData &&
        this.$store.state.userData.iogglysupport == true
      ) {
        return true;
      } else if (this.$store.state.iogglysupportneeded == true) {
        return true;
      } else {
        return false;
      }
    },
    condition2() {
      if (this.$store.state.localCartCount != null) {
        return this.$store.state.localCartCount.length != 0;
      } else {
        return this.$store.state.localCartCount != null;
      }
    },
    showcart() {
      var tempCartData = [];
      this.$store.state.localCart.forEach(e => {
        this.$store.state.allproducts.forEach(i => {
          if (i.spaceid == e.spaceid) {
            tempCartData.push(i);
            if (i.status !== "Verified") {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.cartValid = false;
            } else {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.cartValid = true;
            }
          }
        });
      });
      return tempCartData;
    },
    cartCurrentPrice() {
      return this.priceArr;
    }
  },
  created() {
    this.updateUserData();
  },
  methods: {
    removeCoupon() {
      this.priceArr = this.oldpirceArr;
      this.oldpirceArr = null;
      this.promoError = null;
      this.promoappliedButton = false;
      this.promoEntered = null;
    },
    applyCoupon() {
      this.oldpirceArr = this.priceArr;
      var tempCoupon = [];
      db.collection("promos")
        .get()
        .then(s => {
          s.docs.forEach(d => {
            tempCoupon.push(d.data());
          });
        });

      setTimeout(() => {
        var promoData = null;
        var tempcheck = null;
        var today;
        tempCoupon.forEach(element => {
          if (this.promoEntered.toLowerCase() == element.code.toLowerCase()) {
            promoData = element;
            console.log(element.expdate);
            tempcheck = new Date(element.expdate);
            today = new Date();
          }
        });

        setTimeout(() => {
          if (tempcheck) {
            if (tempcheck.getTime() > today.getTime()) {
              console.log("here");

              if (promoData.discnum !== "") {
                this.promoError = "success";
                this.promoappliedButton = true;
                this.priceArr = [
                  this.priceArr[0],
                  this.priceArr[0],
                  +this.priceArr[2] - +promoData.discnum,
                  +this.priceArr[3] + +promoData.discnum
                ];
              } else {
                if (
                  this.priceArr[2] > promoData.pricelimit ||
                  this.priceArr[2] == promoData.pricelimit
                ) {
                  this.promoError = "success";
                  this.promoappliedButton = true;
                  this.priceArr = [
                    this.priceArr[0],
                    this.priceArr[0],
                    this.priceArr[2] -
                      this.priceArr[2] * (promoData.discount / 100),
                    this.priceArr[3] +
                      this.priceArr[2] * (promoData.discount / 100)
                  ];
                } else {
                  this.promoError = "minimumCart";
                }
              }
            } else {
              this.promoError = "offerExp";
            }
          } else {
            this.promoError = "notCorrect";
          }
        }, 500);
      }, 1000);
    },
    tohome() {
      this.$router.push("/");
    },
    cartCurrentPriceUpdate() {
      if (
        this.$store.state.iogglysupportneeded == true &&
        this.$store.state.localCartCount.length == 0
      ) {
        this.totalPrice = 0;
        this.priceArr = ["0", "0", "0"];
      } else {
        this.totalPrice = 0;
        var discountPrice = 0;

        if (this.$store.state.localCartCount != []) {
          for (var i = 0; i < this.$store.state.localCartCount.length; i++) {
            this.totalPrice =
              +this.totalPrice + +this.$store.state.localCart[i].price;

            discountPrice =
              discountPrice +
              +this.$store.state.localCart[i].price *
                (this.$store.state.localCart[i].discount / 100);
          }
          this.priceArr = [
            this.totalPrice,
            Number(Math.round(this.totalPrice * 0.18 + "e" + 2) + "e-" + 2),
            Number(
              Math.round(this.totalPrice + this.totalPrice * 0.18 + "e" + 2) +
                "e-" +
                2
            ) - discountPrice
          ];
          this.priceArr[3] = discountPrice;
        } else {
          this.totalPrice = 0;
          this.priceArr = ["0", "0", "0"];
        }

        if (this.$store.state.iogglysupportneeded == true) {
          this.priceArr[0] = this.totalPrice + 0;
          this.priceArr[2] = this.priceArr[2] + 0;
        }
      }
    },
    updateUserData() {
      if (this.$store.getters.isAuthenticated == true) {
        setTimeout(() => {
          // db.collection("orgdetails")
          //   .where("uid", "==", this.$store.state.uid)
          //   .get()
          //   .then(s => {
          //     s.docs.forEach(d => {
          //       this.$store.dispatch("updateUserData", {
          //         currentUserData: d.data()
          //       });
          //       this.$store.state.docId = d.id;
          //       this.userData[0] = d.data();
          //     });
          //   });
          if (this.$store.getters.isAuthenticated == true) {
            // this.$store.state.localCart = [];

            if (this.$store.state.localCart.length > 0) {
              for (var i in this.$store.state.localCartCount) {
                for (var j in this.$store.state.allproducts) {
                  if (
                    this.$store.state.allproducts[j].spaceid ==
                      this.$store.state.localCartCount[i] &&
                    !this.$store.state.localCart.some(
                      obj => obj.spaceid === this.$store.state.localCartCount[i]
                    )
                  ) {
                    this.$store.dispatch("updateLocalCart", {
                      localCart: this.$store.state.allproducts[j]
                    });
                  }
                }
              }
            } else {
              for (let i in this.$store.state.localCartCount) {
                for (let j in this.$store.state.allproducts) {
                  if (
                    this.$store.state.allproducts[j].spaceid ==
                    this.$store.state.localCartCount[i]
                  ) {
                    this.$store.dispatch("updateLocalCart", {
                      localCart: this.$store.state.allproducts[j]
                    });
                  }
                }
              }
            }

            if (this.$store.state.localCart.length > 0)
              this.cartCurrentPriceUpdate();

            // this.cartCurrentPriceUpdate();

            // this.$store.state.localCartCount.forEach(element => {
            //   this.$store.state.allproducts.forEach(i => {
            //     if (i.spaceid == element) {
            //       this.$store.dispatch("updateLocalCart", {
            //         localCart: i
            //       });
            //     }
            //   });
            // });
            // this.cartCurrentPriceUpdate();
          }
        }, 0);
      } else {
        this.cartCurrentPriceUpdate();
      }
    },
    checkout() {
      console.log(this.$store.state.userData);
      if (
        this.$store.getters.isAuthenticated == true &&
        this.cartValid == true
      ) {
        // if (this.$store.state.userProfileCount > 8) {
        this.$store.dispatch("setCheckout", {
          checkout: this.$store.state.localCartCount
        });

        this.$store.dispatch("setTotalcartprice", {
          totalcartprice: this.priceArr[2]
        });
        router.push("/checkout");
        // } else {
        //   this.$bvToast.toast("Complete Your Profile First", {
        //     title: "Oops !",
        //     variant: "warning",
        //     solid: true,
        //     toaster: "b-toaster-top-center",
        //     appendToast: false
        //   });
        // }
        //
      } else if (
        this.$store.getters.isAuthenticated == true &&
        this.cartValid == false
      ) {
        this.$bvToast.toast("Some Product Are Out Of Stock", {
          title: "Oops !",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-center",
          appendToast: false
        });
      } else {
        this.$bvToast.toast("Login first in order to Checkout", {
          title: "Oops !",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-center",
          appendToast: false
        });
        this.$store.state.sosOnOff = true;
        this.$store.state.currentSos = "loginWithEmail";
      }
    },
    moveToWishlist(id) {
      if (this.$store.getters.isAuthenticated == true) {
        var promise = db
          .collection("orgdetails")
          .where("uid", "==", this.$store.state.uid)
          .get();
        promise.then(querySnapshot => {
          querySnapshot.forEach(doc => {
            db.collection("orgdetails")
              .doc(doc.id)
              .update({
                wishlist: firebase.firestore.FieldValue.arrayUnion(id)
              })
              .then(() => {
                this.$store.dispatch("updateSnackBar", {
                  message: "Moved To Wishlist"
                });
                this.removeFromCart(id);
                this.$bvToast.toast("Order moved to wishlist", {
                  title: "Yheaa",
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-top-center",
                  appendToast: false
                });
              });
          });
        });
      } else {
        this.$bvToast.toast("Login first in order to add to wishlist", {
          title: "Oops !",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-center",
          appendToast: false
        });
      }
    },
    removeIogglySupport() {
      this.$store.state.iogglysupportneeded = false;
      this.cartCurrentPriceUpdate();
    },
    addIogglySupport() {
      this.$store.state.iogglysupportneeded = true;
      this.cartCurrentPriceUpdate();
      this.$bvToast.toast("Adding Ioggly Support to your cart", {
        title: "Hi There !",
        variant: "warning",
        solid: true,
        toaster: "b-toaster-top-center",
        appendToast: false
      });

      // var promise = db
      //   .collection("orgdetails")
      //   .where("uid", "==", this.$store.state.uid)
      //   .get();
      // promise.then(querySnapshot => {
      //   querySnapshot.forEach(doc => {
      //     db.collection("orgdetails")
      //       .doc(doc.id)
      //       .update({
      //         iogglysupportneeded: true
      //       })
      //       .then(this.updateUserData);
      //   });
      // });
    },
    removeFromCart(id) {
      if (this.$store.getters.isAuthenticated == true) {
        if (this.$store.state.localCartCount.length > 1) {
          this.$store.state.localCart = this.$store.state.localCart.filter(
            item => item.spaceid !== id
          );
          this.$store.state.localCartCount = this.$store.state.localCartCount.filter(
            item => item !== id
          );
        } else {
          this.$store.state.localCart = [];
          this.$store.state.localCartCount = [];
        }

        db.collection("orgdetails")
          .doc(this.$store.state.docId)
          .set(
            {
              cart: this.$store.state.localCartCount
            },
            { merge: true }
          )
          .then(() => {
            this.cartCurrentPriceUpdate();
            db.collection("orgdetails")
              .where("uid", "==", this.$store.state.uid)
              .get()
              .then(s => {
                s.docs.forEach(d => {
                  this.$store.dispatch("updateUserData", {
                    currentUserData: d.data()
                  });
                  this.$store.state.docId = d.id;
                  this.userData[0] = d.data();
                });
              });
          });
      } else {
        if (this.$store.state.localCartCount.length > 1) {
          this.$store.state.localCart = this.$store.state.localCart.filter(
            item => item.spaceid !== id
          );
          this.$store.state.localCartCount = this.$store.state.localCartCount.filter(
            item => item !== id
          );
        } else {
          this.$store.state.localCart = [];
          this.$store.state.localCartCount = [];
        }

        this.cartCurrentPriceUpdate();

        // this.totalPrice = 0;

        // if (this.$store.state.localCart.cart.length > 1) {
        //   this.$store.dispatch("updateLocalCart", {
        //     localCart: this.cart.filter(item => item.spaceid !== id)
        //   });
        // } else {
        //   this.$store.dispatch("updateLocalCart", {
        //     localCart: []
        //   });
        // }

        // if (this.$store.state.localCartCount.length > 1) {
        //   this.$store.dispatch("updateLocalCartCount", {
        //     localCartCount: this.lCartCount.filter(i => i !== id)
        //   });
        // } else {
        //   this.$store.dispatch("updateLocalCartCount", {
        //     localCartCount: []
        //   });
        // }

        // this.cart = this.$store.state.localCart;

        // this.$store.state.localCart.forEach(item => {

        //   this.totalPrice = +this.totalPrice + +item.price;

        //   //  this.totalPrice =
        //   //     +this.totalPrice - +change.doc.data().price;
        // });
      }
    }
  }
};
</script>

<style scoped>
.promo-parent {
  padding: 0 25px;
}
#promo-input {
  font-size: 16px;
  padding: 2px 3px;
  margin: 20px 10px;
  outline: none;
  border-bottom: 1px solid black;
}
.style-1 {
  margin-top: 10px;
}
.style-1 del {
  color: gray;
  text-decoration: none;
  position: relative;
}
.style-1 del:before {
  content: " ";
  display: block;
  width: 100%;
  border-top: 2px solid rgba(0, 0, 0, 0.8);
  height: 10px;
  position: absolute;
  bottom: 0;
  left: 1px;
  transform: rotate(0deg);
}
.style-1 ins {
  color: black;
  font-size: 18px;
  text-decoration: none;
  padding: 0em 0em 0em 0.5em;
}
@media only screen and (min-width: 1000px) {
  .securepay {
    margin: 30px 0px 10px;
    width: 310px;
  }
  .securepayimg {
    width: 29px;
    height: 36px;
    margin-right: 20px;
    float: left;
  }
  .securepaydec {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.29;
    display: block;
    margin-left: 49px;
    color: #878787;
  }
  #cart-parent {
    padding-top: 50px;
    min-height: max-content;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    margin-bottom: 10px;
  }
  #productInCart {
    width: 50%;
    height: max-content;
    margin: 10px 10px 0 0;
    float: left;
  }
  #payment {
    width: max-content;
    float: right;
    margin: 10px 0 0 10px;
    right: 0;
  }

  #cartcc {
    text-transform: uppercase;
    color: #212121;
    font-size: 16px;
    font-weight: 500;
    /* border-bottom: 1px solid #f0f0f0; */
    padding: 16px 31px 0 25px;
  }

  .productdet {
    display: flex;
  }
  .productspec {
    padding: 0 24px 12px;
    vertical-align: top;
    min-height: 112px;
    -webkit-flex: 1 1;
    -ms-flex: 1 1;
    flex: 1 1;
    overflow: hidden;
    max-width: 440px;
  }
  .productbtn {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0;
  }

  .gobacktoshopping {
    position: sticky;
    bottom: 0;
    padding: 16px 23px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    background: #fff;
    border-top: 1px solid #f0f0f0;
    box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.1);
  }
  .actionbtn {
    font-size: 16px !important;
    font-weight: 500 !important;
  }

  #staticData {
    float: left;
    padding: 0 24px;
    font-size: 15px;
    margin-top: 20px;
    font-weight: bold;
  }
  #dyanamicData {
    float: right;
    padding: 0 24px;
    font-size: 15px;
    margin-top: 20px;
  }
  .paymentInfo {
    height: 220px;
    width: 385px;
    position: relative;
    margin: 0 0 10px 0;
  }
  .paymentInfo2 {
    /* top: 325px; */
    height: 13.5rem;
    position: relative;
    width: 385px;
    padding: 10px;
    display: flex;
    flex-direction: row;
  }

  #iogglysupport {
    display: flex;
  }
  .productImage {
    width: 150px;
  }
  .productHeading {
    /* margin-left: 175px;
  margin-bottom: 0px;
  font-size: 1.5em; */
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 5px;
  }
  .productSubHeading {
    /* margin-left: 175px;
  margin-bottom: 0px; */
    margin-top: 11px;
    display: block;
    color: #878787;
    font-size: 12px;
  }
  .productDimension {
    /* margin-left: 175px;
  font-size: 0.9em; */
    margin-top: 5px;
    display: block;
    color: #878787;
    font-size: 12px;

    width: 15em !important;
  }
  .productPrice {
    /* margin-bottom: 2px;
  margin-left: 175px; */
    font-size: 18px;
    font-weight: 500;
    color: #212121;
  }
  .productDelivery {
    float: right;
  }
  .productOffer {
    float: right;
    margin-top: 20px;
    left: 94px;
    position: relative;
  }
  .ux-card {
    padding: 20px;
    position: relative;
    margin: 10px;
    height: 190px;
    display: flex;
  }
  .empty-cart {
    height: 70vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .empty-cart > p {
    margin-top: 10px;
    font-size: 20px;
    word-wrap: break-word;
  }
  .empty-cart > h2 {
    font-weight: normal;
    margin-top: 20px;
  }
  .pricedete {
    display: block;
    text-transform: uppercase;
    padding: 13px 24px;
    font-weight: 500;
    font-size: 16px;
    color: #878787;
    min-height: 47px;
    border-radius: 2px 2px 0 0;
    border-bottom: 1px solid #f0f0f0;
  }
  .checkoutnow {
    border-top: 1px solid #f0f0f0;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  .support1 {
    display: flex;
    width: 60%;
    flex-direction: column;
    font-size: 16px;
    padding-top: 10px;
  }
  .support-price {
    margin-top: 15px;
    font-size: 3rem;
    font-weight: normal;
  }
  .support2 {
    display: flex;
    width: 40%;
    flex-direction: column;
    padding-top: 10px;
  }
  .supportill {
    width: 100%;
    height: 50%;
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 600px) {
  .productDimension {
    width: 15em !important;
    line-height: 1.3 !important;
  }
  .empty-cart {
    justify-content: center;
    text-align: center;
    padding: 35px;
  }
  #cart-parent {
    display: flex;
    flex-flow: column;
    margin-top: 60px;
  }
  #cartcc {
    text-transform: uppercase;
    color: #212121;
    font-size: 12px;
    font-weight: 500;
    padding: 10px 22px 0 15px;
  }
  #productInCart {
    width: 95%;
    margin: 0 auto;
  }
  .ux-card {
    position: relative;
    display: flex;
    flex-flow: column;
  }
  .productdet {
    display: flex;
    flex-flow: row;
    padding: 0 15px;
  }
  .productImage {
    height: 100px;
    width: 120px;
    margin: auto;
  }
  .productspec {
    margin: auto;
    line-height: 0.8;
    font-size: 12px;
  }
  .productbtn {
  }
  .gobacktoshopping {
    display: flex;
    background: #fff;
    border-top: 1px solid #f0f0f0;
    margin-top: 25px;
    justify-content: center;
    flex-flow: column;
  }
  #payment {
    width: 95%;
    margin: 15px auto;
  }
  .paymentInfo {
    height: 190px;
    display: flex;
    flex-flow: row;
    justify-content: center;
    padding: 70px 0 0 0;
  }
  .pricedete {
    display: block;
    text-transform: uppercase;
    padding: 13px 15px;
    font-weight: 500;
    font-size: 12px;
    color: #878787;
    min-height: 47px;
    border-bottom: 1px solid #f0f0f0;
    position: absolute;
    top: 0;
  }
  #staticData {
    font-size: 12px;
    margin-right: 10%;
  }
  #dyanamicData {
    font-size: 12px;
    margin-left: 10%;
  }
  .securepay {
    display: flex;
    flex-flow: row;
    margin-top: 10px;
  }
  .securepaydec {
    font-size: 12px;
    margin: auto;
  }
  .paymentInfo2 {
    display: flex;
    flex-flow: row;
    margin-top: 10px;
  }
  .support1 {
    width: 60%;
    padding: 13px;
  }
  .support2 {
    width: 40%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    padding: 10px;
  }
  .supportill {
    height: 75px;
  }
}
</style>
